// Типы для поиска
export interface SearchUsersRequest {
    search: string;
    limit?: number;
    is_blocked?: boolean;
}

export interface SearchCharityRequest {
    query: string;
    limit?: number;
}

export interface UserSearchResult {
    id: number;
    name: string;
    surname: string;
    email: string;
    mobile: string | null;
    secret_cookie: string | null;
    ref_link: string | null;
}

export interface CharitySearchResult {
    users_donate_id: number;
    users_donate_user_id: number;
    users_donate_walet: number;
    users_donate_usdt_walet: number;
    users_donate_status: number;
    user: {
        id: number;
        name: string;
        surname: string;
        email: string;
        mobile: string | null;
        secret_cookie: string | null;
    } | null;
}

export const searchEndpoints = {
    searchUsers: {
        query: (params: SearchUsersRequest) => ({
            url: "/users",
            params,
        }),
    },

    searchCharity: {
        query: (params: SearchCharityRequest) => ({
            url: "/admin/balance/search-charity",
            params,
        }),
    },
};

export const searchTags = ["Search"] as const;
